import React, { useMemo, useState } from 'react';
import { formatDecimal as fmt } from '../../helpers/paymentsHelper';

const ToggleTable = ({ data }) => {
  const getByPath = (obj, path) =>
    path.split('.').reduce((acc, key) => (acc?.[key] ?? undefined), obj);

  const cmp = (a, b) => {
    if (a == null && b == null) return 0;
    if (a == null) return 1;
    if (b == null) return -1;

    const aNum = Number(a);
    const bNum = Number(b);
    const bothNumbers = !Number.isNaN(aNum) && !Number.isNaN(bNum);
    if (bothNumbers) return aNum - bNum;

    return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
  };

  const [expandedRows, setExpandedRows] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [searchQuery, setSearchQuery] = useState('');

  const handleRowClick = (id) => {
    setExpandedRows((prevExpandedRows) =>
      prevExpandedRows.includes(id)
        ? prevExpandedRows.filter((rowId) => rowId !== id)
        : [...prevExpandedRows, id]
    );
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') direction = 'desc';
    setSortConfig({ key, direction });
  };

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return data;
    const dir = sortConfig.direction === 'asc' ? 1 : -1;
    return [...data].sort((a, b) => dir * cmp(getByPath(a, sortConfig.key), getByPath(b, sortConfig.key)));
  }, [data, sortConfig]);


  const filteredData = sortedData.filter((item) =>
    Object.values(item).some((value) =>
      value.toString().toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <div className="w-full h-full">
      <div className="px-1" style={{ maxWidth: '220px' }}>
        <div className="relative flex items-center">
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ paddingTop: '0.44rem', paddingBottom: '0.44rem' }}
            className="w-full pl-4 pr-10 text-gray-800 bg-white border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 placeholder-gray-400 placeholder-opacity-100 font-light text-sm"
          />
          <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </div>
        </div>
      </div>
      <div
        className="overflow-y-auto w-full scrollbar"
        style={{ maxHeight: '600px' }}>
        <table className="border-collapse w-full h-10/12">
          <thead>
            <tr>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('company_name')}>
                Company{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'company_name' &&
                      sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'company_name' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              {/* <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('age')}>
                Week{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'age' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'age' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th> */}
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.date_range')}>
                Date Range{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.date_range' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.date_range' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.trips')}>
                Total Trips{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.trips' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.trips' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.billable_trips')}>
                Billable Trips{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.billable_trips' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.billable_trips' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.total_payout')}>
                Total Pay{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.total_payout' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.total_payout' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.ten')}>
                0-19 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.ten' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.ten' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.twenty')}>
                20-29 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.twenty' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.twenty' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.thirty')}>
                30-39 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.thirty' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.thirty' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.forty')}>
                40-49 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.forty' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.forty' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.fifty')}>
                50-59 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.fifty' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.fifty' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.sixty')}>
                60-69 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.sixty' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.sixty' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.seventy')}>
                70-79 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.seventy' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.seventy' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.eighty')}>
                80-89 KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.eighty' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.eighty' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.ninety_plus')}>
                90+ KMs{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.ninety_plus' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.ninety_plus' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
              <th
                className="border-b p-2 cursor-pointer text-left"
                onClick={() => handleSort('toggle_table.cancellations')}>
                Cancellations{' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="16"
                  height="32"
                  className="inline-block ml-1">
                  <path
                    d="M12 5l-5 5h10l-5-5z"
                    fill={
                      sortConfig.key === 'toggle_table.cancellations' && sortConfig.direction === 'asc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />

                  <path
                    d="M12 19l5-5H7l5 5z"
                    fill={
                      sortConfig.key === 'toggle_table.cancellations' &&
                      sortConfig.direction === 'desc'
                        ? '#745D96'
                        : '#9C9C9C'
                    }
                  />
                </svg>
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item) => (
              <React.Fragment key={item.company_id}>
                <tr className="border-t border-b p-2 cursor-pointer">
                  <td className="border-t border-b p-2 text-gray-400 font-medium text-left">
                    {item.company_name}
                  </td>
                  {/* <td className="border-t text-gray-400 border-b p-2 text-left">
                    {item.toggle_table.week_start}
                  </td> */}
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {item.toggle_table.date_range}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {item.toggle_table.trips}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {item.toggle_table.billable_trips}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-left">
                    {fmt(item.toggle_table.total_payout)}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.ten}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.twenty}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.thirty}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.forty}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.fifty}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.sixty}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.seventy}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.eighty}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.ninety_plus}
                  </td>
                  <td className="border-t text-gray-400 border-b p-2 text-center">
                    {item.toggle_table.cancellations}
                  </td>
                  <td className="border-t border-b p-2 space-x-1">
                    <button
                      onClick={() => handleRowClick(item.company_id)}
                      className="p-2 bg-gray-700 rounded hover:bg-gray-200">
                      {expandedRows.includes(item.company_id) ? (
                        <svg
                          width="20"
                          height="10"
                          viewBox="0 0 20 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M19 1C16.6 3.667 13.6 5 10 5C6.4 5 3.4 3.667 1 1M1 7.00001L3.5 3.20001M18.9998 6.97601L16.5078 3.20001M7 9L7.5 5M13 9L12.5 5"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="14"
                          viewBox="0 0 20 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M8 7C8 7.53043 8.21071 8.03914 8.58579 8.41421C8.96086 8.78929 9.46957 9 10 9C10.5304 9 11.0391 8.78929 11.4142 8.41421C11.7893 8.03914 12 7.53043 12 7C12 6.46957 11.7893 5.96086 11.4142 5.58579C11.0391 5.21071 10.5304 5 10 5C9.46957 5 8.96086 5.21071 8.58579 5.58579C8.21071 5.96086 8 6.46957 8 7Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M19 7C16.6 11 13.6 13 10 13C6.4 13 3.4 11 1 7C3.4 3 6.4 1 10 1C13.6 1 16.6 3 19 7Z"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </button>
                  </td>
                </tr>
                {expandedRows.includes(item.company_id) && (
                  <>
                    <tr>
                      <td className='p-2'>{" "}</td>
                      <td className='p-2'>{" "}</td>
                      <td className='p-2'>{" "}</td>
                      <td className='p-2'>{" "}</td>
                      <td
                        className="text-gray-400 font-bold border-t border-b p-2 text-left">
                        {item.toggle_table.sedan.vehicle}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.ten}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.twenty}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.thirty}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.forty}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.fifty}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.sixty}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.seventy}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.eighty}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.ninety_plus}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {item.toggle_table.sedan.cancellations}
                      </td>
                      <td
                        className="text-gray-400 border-t border-b p-2 text-center">
                        {" "}
                      </td>
                    </tr>

                  <tr>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td
                      className="text-gray-400 font-bold border-t border-b p-2 text-left">
                      {item.toggle_table.van.vehicle}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.ten}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.twenty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.thirty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.forty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.fifty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.sixty}
                    </td>
                    <td
                       

                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.seventy}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.eighty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.ninety_plus}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.van.cancellations}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {" "}
                    </td>
                  </tr>

                  <tr>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td
                      className="text-gray-400 font-bold border-t border-b p-2 text-left">
                      {item.toggle_table.minibus.vehicle}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.ten}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.twenty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.thirty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.forty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.fifty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.sixty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.seventy}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.eighty}
                    </td>
                    <td
                       
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.ninety_plus}
                    </td>
                    <td

                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.minibus.cancellations}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">

                    </td>
                  </tr>

                  <tr>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td className='p-2'>{" "}</td>
                    <td
                      className="text-gray-400 font-bold border-t border-b p-2 text-left">
                      {item.toggle_table.hatchback.vehicle}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.ten}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.twenty}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.thirty}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.forty}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.fifty}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.sixty}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.seventy}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.eighty}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.ninety_plus}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">
                      {item.toggle_table.hatchback.cancellations}
                    </td>
                    <td
                      className="text-gray-400 border-t border-b p-2 text-center">

                    </td>
                  </tr>
                </>

                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ToggleTable;